/**
 * Routes of area (h) — tech. OWNED BY area (h) — tech: tighten `validateSearch`, add loaders, swap `component`
 * for the real screen (keep the paths — boards.ts hrefs point at them). Generated by the foundation.
 */
import { createRoute } from "@tanstack/react-router";
import { boardsAt } from "@/boards/board-switch";
import { guard, looseSearch, staffRoute } from "@/app/route-base";

/** TD-Console */
export const techniqueRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/technique",
  validateSearch: looseSearch,
  beforeLoad: guard("tech.console", "read"),
  component: boardsAt("/technique"),
});

/** TD-Developpeurs */
export const techniqueDeveloppeursRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/technique/developpeurs",
  validateSearch: looseSearch,
  beforeLoad: guard("tech.developers", "read"),
  component: boardsAt("/technique/developpeurs"),
});

/** TD-RSSI */
export const techniqueRssiRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "/technique/rssi",
  validateSearch: looseSearch,
  beforeLoad: guard("tech.security", "read"),
  component: boardsAt("/technique/rssi"),
});

export const techRoutes = [techniqueRoute, techniqueDeveloppeursRoute, techniqueRssiRoute] as const;
